import axiosClient from "@shared/Axios/client";

const endPoint = "customer";

export const commonServices = {
    deliveryProducts: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/deliveryProducts`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    nearByFuelStation: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/nearByFuelStation`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    addToCart: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/addToCart`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getCountries: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/getCountries`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getCities: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/getStates`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    addAddress: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/addAddress`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    editAddress: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/editAddress`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    userAllAddress: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/userAllAddress`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    myCart: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/myCart`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    deliveryCheckout: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/deliveryCheckout`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    deliveryConfirmOrder: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/deliveryConfirmOrder`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    categories: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/categories`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    productInfo: async (data) => {
        try {
            const res = await axiosClient.get(`${endPoint}/productInfo/${data}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    updateLatLongs: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updateLatLongs`, data);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getProfile: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/myProfile`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getNotifications: async (pageNumber, pageSize) => {
        try {
            const res = await axiosClient.get(`${endPoint}/getNotifications?pageNumber=${pageNumber}&pageSize=${pageSize}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getNotificationCount: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/getNotificationCount`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    enableWallet: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/enableWallet`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    verifyBVN: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/enableWallet`, data);

            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getDashboardDetails: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/getDashboardDetails`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    addFund: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/wallet/fund`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    vendorInfo: async (data) => {
        try {
            const res = await axiosClient.get(`${endPoint}/vendorInfo/${data.id}?lat=${data.lat}&lng=${data.lng}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },


    getWalletStatus: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/getWalletDetails`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    addFav: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/addFavouriteCustomer`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    removeFav: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/removeFavouriteCustomer`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getLoyalityCards: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/getLoyalityCards`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fOrderList: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/orders`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    orderTracking: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/orderTracking`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },


    getPaymentDetails: async (data) => {
        try {
            const res = await axiosClient.get(`${endPoint}/orderPaymentDetails/${data}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    paymentHistory: async (pageNumber, pageSize) => {
        try {
            const res = await axiosClient.get(`${endPoint}/paymentHistory?pageNumber=${pageNumber}&pageSize=${pageSize}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    checkPromoCode: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/checkPromoCode`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },
    getFaqList: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/getFaqList`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    updatePassword: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updatePassword`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getFavouriteProducts: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/getFavouritesCustomer`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getFavouriteVendors: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/getFavouritesCustomer`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    contactSupport: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/supportReqAdd`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getSupportList: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/supportReqList`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    updateProfile: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updateProfile`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getLoyalityPointsHistory: async (pageNumber, pageSize) => {
        try {
            const res = await axiosClient.get(`${endPoint}/loyalityPointsHistory?pageNumber=${pageNumber}&pageSize=${pageSize}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getSearchProductsAndVendors: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/getSearchProductsAndVendors`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    updateImage: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updateImage`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    generateInvoice: async (orderId) => {
        try {
            const res = await axiosClient.get(`${endPoint}/generateInvoice/${orderId}/1`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },


    deleteAccount: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/deleteAccount`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

};